import styled from "styled-components";
import { Tag } from "../../../../../components/atoms/Tag/Tag";
import { EllipsisMultiText } from "../../../../../components/organisms/Tooltip/Tooltip";

const TagItem = styled.span`
  display: inline-flex;

  &:not(:last-child) {
    margin-right: 8px;
  }
`;

/**
 * Distinct display names from a list of {id, name} records or plain strings.
 *
 * @param {Array<object|string>|undefined} items
 * @return {string[]}
 */
export function shipmentTagNames(items) {
  const seen = new Set();
  const names = [];
  (items ?? []).forEach(item => {
    const name = (typeof item === "string" ? item : item?.name || "").trim();
    const key = typeof item === "object" && item?.id != null ? item.id : name;
    if (!name || seen.has(key)) return;
    seen.add(key);
    names.push(name);
  });
  return names;
}

/**
 * Shows every name as a table tag, the same way shipment orders are shown.
 *
 * @param {Object} props
 * @param {Array<object|string>|undefined} props.items
 * @param {number=} props.width
 * @param {string=} props.empty
 * @return {JSX.Element}
 */
export function ShipmentNameTagsCell({ items, width = 100, empty = "Not Applicable" }) {
  const names = shipmentTagNames(items);
  const label = names.length ? names.join(", ") : empty;

  return (
    <EllipsisMultiText text={label} width={width}>
      {names.length
        ? names.map(name => (
            <TagItem key={name}>
              <Tag className="in-table">{name}</Tag>
            </TagItem>
          ))
        : empty}
    </EllipsisMultiText>
  );
}
